module.exports = __webpack_public_path__ + "static/media/pg.7f02140d.png";